import { featureFlags } from './feature-flags';

export const api = { featureFlags };
